import { render, staticRenderFns } from "./StatementNewItem.vue?vue&type=template&id=a870c71c&scoped=true"
import script from "./StatementNewItem.vue?vue&type=script&lang=js"
export * from "./StatementNewItem.vue?vue&type=script&lang=js"
import style0 from "./StatementNewItem.vue?vue&type=style&index=0&id=a870c71c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a870c71c",
  null
  
)

export default component.exports